export class TaskStatus {
  TypeId: number
  DateValue: string
  StatusCode: string
}